import { Component, OnInit, Inject } from "@angular/core";
import { UtilsService } from "src/app/services/utils/utils.service";
import { SeoService } from "src/app/services/seo/seo.service";
import projects from "src/assets/projects";
import { PATHS, ROUTES } from "src/constants";

@Component({
  selector: "app-works-de",
  templateUrl: "./works-de.component.html",
  styleUrls: ["./works-de.component.scss"],
})
export class WorksDeComponent implements OnInit {
  public ROUTES = ROUTES;
  public PATHS = PATHS;
  public projects = projects;

  constructor(private utils: UtilsService, private seo: SeoService, @Inject("isBrowser") private isBrowser: boolean) {}

  ngOnInit() {
    this.seo.updateMeta({
      title: "coara - unsere arbeit",
      description:
        "Genießen Sie eine Auswahl unserer Projekte. " +
        "Wir sind leidenschaftlich innovativ und möchten Ihre Ideen Wirklichkeit werden lassen.",
      imageUrl: "https://coara.co/assets/images/sharing/facebook.jpg",
    });
    this.seo.setCanonicalURL();
  }

  public preloadProjectImage(project): void {
    if (this.isBrowser) {
      this.utils.preloadImage([project.image]);
    }
  }

  public trackBy(i: number): number {
    return i;
  }
}
